module.exports = __webpack_public_path__ + "static/img/register-left-bg.9696ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register/register-left-bg.png
// module id = wIli
// module chunks = 1